import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin, Typography, message } from 'antd';
import { useAuth } from '../store/auth';

// Приём кода от Keycloak: обмен (через бэкенд) -> токены ТЕРРА-СУП -> вход
export default function OidcCallbackPage() {
  const { oidcLogin } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState(null);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const errorParam = params.get('error');
    if (errorParam) {
      setError(`SSO: ${errorParam}`);
      message.error('Вход через SSO не удался');
      setTimeout(() => navigate('/login', { replace: true }), 1500);
      return;
    }

    const code = params.get('code');
    const state = params.get('state');
    const verifier = sessionStorage.getItem('oidc_verifier');
    const expectedState = sessionStorage.getItem('oidc_state');

    if (!code || !verifier) {
      setError('Нет кода авторизации');
      setTimeout(() => navigate('/login', { replace: true }), 1500);
      return;
    }
    if (expectedState && state && expectedState !== state) {
      setError('Несовпадение state (безопасность)');
      setTimeout(() => navigate('/login', { replace: true }), 1500);
      return;
    }

    oidcLogin(code, verifier)
      .then(() => {
        sessionStorage.removeItem('oidc_verifier');
        sessionStorage.removeItem('oidc_state');
        sessionStorage.removeItem('oidc_back_to_local');
        navigate('/', { replace: true });
      })
      .catch(() => {
        setError('Не удалось завершить вход (обмен кода)');
        setTimeout(() => navigate('/login', { replace: true }), 1500);
      });
  }, [params, oidcLogin, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 20,
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }}>
      <Spin size="large" />
      <Typography.Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: 16 }}>
        {error || 'Завершаем вход в ТЕРРА-СУП…'}
      </Typography.Text>
    </div>
  );
}
